export default "__VITE_ASSET__xt263zOH__"